import React, {useState} from "react";
import "./Letter.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Letter = ({solved, readId, overWriteFunction, index}) => {
    const mainDiv = (
        <>
            <h4 className="letter-display">{readId}</h4>
        </>
    );

    return (
        <RiddleCard title={"Letter"} allSolved={solved} mainInfo={mainDiv} connected={readId !== null} overwriteString={overWriteFunction} index={index}></RiddleCard>
    )
}

export default Letter;